import * as Yup from 'yup';

const AddUserValidationSchema = (t: any) =>
    Yup.object().shape({
        firstName: Yup.string()
            .min(2, t('firstname_min_length_validation'))
            .max(50, t('firstname_max_length_validation'))
            .trim(t('space_not_allowed_validation'))
            .required(t('firstname_required_validation')),
        lastName: Yup.string()
            .min(2, t('lastname_min_length_validation'))
            .max(50, t('lastname_max_length_validation'))
            .trim(t('space_not_allowed_validation'))
            .required(t('lastname_required_validation')),
        email: Yup.string()
            .email(t('invalid_email_validation'))
            .trim(t('space_not_allowed_validation'))
            .matches(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/, 'Please enter a valid Email ID')
            .required(t('email_required_validation')),
        mobileNo: Yup.string()
            .min(10, t('mobileno_min_length_validation'))
            .max(10, t('mobileno_max_length_validation'))
            .matches(/^\+?[0-9\s\-().]{7,20}$/, 'Please enter a valid Mobile number')
            .required(t('mobile_no_required_validation')),
        street: Yup.string()
            .min(2, 'Street should be atleast 3 characters')
            .max(100, 'Street should be a max of 30 characters')
            .trim('Starting spaces are not allowed')
            .required('Street Name required'),
        city: Yup.string()
            .min(2, 'City Name should be atleast 3 characters')
            .max(50, 'City Name should be a max of 30 characters')
            .trim('Starting spaces are not allowed')
            .required('City Name required'),
        state: Yup.string().required('Select State'),
        country: Yup.string().required('Select Country'),
        zipCode: Yup.string()
            .min(5, 'ZIP code must be at least 5 digits long.')
            .max(10, 'ZIP code cannot exceed 10 digits')
            .matches(/^([1-9]\d{5}|\d{5}(-\d{4})?)$/, 'Please enter a valid zip code')
            .required('Zip Code is required'),
    });

export default AddUserValidationSchema;
